export const AVTALEGIRO_FORM_URL = "https://pvu.avtalegiro.no/ecsa/start";
export const AVTALEGIRO_COMPANY_NAME = "Effektiv Altruisme Norge";
export const AVTALEGIRO_COMPANY_ACCOUNT_NO = "15062995960";
/** The lowest monthly amount limit we ask donors to approve in their bank */
export const AVTALEGIRO_MIN_AMOUNT_LIMIT = 20000;
